import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetChecklistItemsAction } from '../../actions/checklist-items/get-checklist-items-action';
import { GetChecklistItemsSuccessAction } from '../../actions/checklist-items/get-checklist-items-success-action';
import { GetChecklistItemsErrorAction } from '../../actions/checklist-items/get-checklist-items-error-action';

@Injectable()
export class GetChecklistItemsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetChecklistItemsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetChecklistItemsAction.type),
      mergeMap(action => {
        const getChecklistItemsAction = <GetChecklistItemsAction>action;
        return this.api.getChecklistItems(getChecklistItemsAction.bijbEvent).then(items => {
          return new GetChecklistItemsSuccessAction(items);
        }, error => {
          return new GetChecklistItemsErrorAction(error);
        });
      })
    ));
}
